import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { ProgressNotesModel } from '../models/ProgressNotesModel';
import { DiganosisModel } from '../models/DiganosisModel';


@Injectable()
export class DiganosisService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

    public getDiganosisPatient(PatientCode: string) {
      let params = new HttpParams();
      params = params.append("PatientCode", PatientCode);
      const options = {
          params: params
      };
      return this.http.get<DiganosisModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Diganosis/GetDiganosis_Patient', options);
    }
    public getDiganosis(PatientCode: string,DigDate:string ) {
      let params = new HttpParams();
      params = params.append("DigDate", DigDate);
      params = params.append("PatientCode", PatientCode);
      const options = {
          params: params
      };
      return this.http.get<DiganosisModel>(this.urlsconfig.WebAPIURL_Test + 'api/Diganosis/GetDiganosis', options);
    }
    public AddDiganosis(Diganosis: DiganosisModel) {
            return this.http.post<DiganosisModel>(this.urlsconfig.WebAPIURL_Test + 'api/Diganosis/AddDiganosis', Diganosis);
    }
    public deleteDiganosis(DigDate:string ,PatientCode: string) {
      let params = new HttpParams();
      params = params.append("DigDate", DigDate);
      params = params.append("PatientCode", PatientCode);
      const options = {
          params: params
      };
      return this.http.get<DiganosisModel>(this.urlsconfig.WebAPIURL_Test + 'api/Diganosis/DelDiganosis', options);
    }
}
